import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import Alert from "../../../Common/Alert";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";
import { Dialog } from "primereact/dialog";
import useRequiredFields from "../../../../hooks/useRequiredFields";

const ChangeProductClass = () => {
  const [planningData, setPlanningData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [role, setRole] = useState(""); // State to hold the role
  const [visible, setVisible] = useState(false);
  const [item, setItem] = useState({});
  const [inputs, setInputs] = useState();
  const { checkRequiredFields } = useRequiredFields();
  // Fetch data from /planning API
  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await Http.get("/product-class-change");
      const transferData = res.data; // Root-level array

      setPlanningData(transferData);
      // setPlanningData(dummy);

      Http.get("/staff-type-check").then((res) => {
        setRole(res.data);
      });
      Http.get("/me").then((res) => {
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const openModal = (item) => {
    setItem({});
    setVisible(true);
    setItem(item);
    setInputs((prevValues) => ({
      ...prevValues,
      production_finished_good_transfer_item_id: item?.id,
    }));
    return;
  }

  const cols = [
    {
      header: "Product Code",
      field: (item) => (
        <div>
          {item?.product?.code} {/* Display product code */}
        </div>
      ),
    },
    {
      header: "Product Name",
      field: (item) => (
        <div>
          {item?.product?.name}
        </div>
      ),
    },
    {
      header: "Planning No",
      field: (item) => (
        <div>
          {item?.planning?.receipt_no}
        </div>
      ),
    },
    {
      header: "Company",
      field: (item) => (
        <div>
          {item?.production_work_order?.company?.name} <strong>#{item?.production_work_order?.receipt_no}</strong>
        </div>
      ),
    },
    {
      header: "Shape",
      field: (item) => (
        <div>
          {item?.shape?.name}
        </div>
      ),
    },
    {
      header: "Qty Export",
      field: (item) => (
        <div>
          {item?.delivery_qty_export}
        </div>
      ),
    },
    {
      header: "Qty A Class",
      field: (item) => (
        <div>
          {item?.delivery_qty_a_class}
        </div>
      ),
    },
    {
      header: "Qty B Class",
      field: (item) => (
        <div>
          {item?.delivery_qty_b_class}
        </div>
      ),
    },
    {
      header: "Qty C Class",
      field: (item) => (
        <div>
          {item?.delivery_qty_c_class}
        </div>
      ),
    },
    {
      header: "Action",
      field: (item) => (
        <div>
          <button className="btn btn-primary" onClick={() => openModal(item)}>
            <i className="fa fa-edit" aria-hidden="true"></i>
          </button>
        </div>
      ),
    },
  ];
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    checkRequiredFields();
    try {
      const res = await Http.post("/transfer-to-class", inputs);
      const data = await res.data;
      fetchData();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.error || "Something went wrong!",
      })
    } finally {
      setVisible(false);
      setInputs({});
    }
  }

  console.log(inputs)

  return (
    <div>
      <IsLogin />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Products Transfer To C Class</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <ReactDataTable
              cols={cols}
              receiveData={planningData}
              isLoading={loading}
              role={role}
            />
          </div>
        </div>
      </div>
      <Dialog header="Transfer to C Class" visible={visible} style={{ width: '50vw' }} onHide={() => { if (!visible) return; setVisible(false); }}>
        <>
          <div className="card pd-20 pd-sm-40">
            <form onSubmit={handleSubmit}>
              <input type="hidden" value={item?.id} name="production_finished_good_transfer_item_id" />
              <div className="form-group">
                <label htmlFor="type">Product Class<strong className="text-danger">*</strong> </label>
                <select className="form-control" id="type" name="product_class" onChange={handleChange} data-required>
                  <option value="" disabled selected>Select Class</option>
                  <option value="Export">Export</option>
                  <option value="A">A Class</option>
                  <option value="B">B Class</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="qty">Product Qty<strong className="text-danger">*</strong></label>
                <input type="number" id="qty" name="qty" className="form-control" placeholder="Enter Product Qty" onChange={handleChange} data-required />
              </div>
              <button className="btn btn-primary">
                Submit
              </button>
            </form>
          </div>
        </>
      </Dialog>
    </div>
  );
};

export default ChangeProductClass;
